const ItemTypes = {
  MATCH: 'match',
};

export default ItemTypes;
